const doc = [({"en":({"js":({"admin":({"highscore_generations":({"show":({"generation_at_date_in_highscore":"Generation at %{generated_at} in %{highscore_name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;